import Request from "@/services/request/index";

export const get = (params) => {
  return Request.get({ url: "/exam/registration/get", params });
};

export const create = (data) => {
  return Request.post({ url: "/exam/registration/create", data });
};

export const update = (data) => {
  return Request.post({ url: "/exam/registration/update", data });
};

// 报名统计（按岗位）：仅报名中且考试开启展示时返回数据
export const getPostStatList = (params) => {
  return Request.get({ url: "/exam/registration/post-stat-list", params });
};
